export default "/images/0dc2d1dae52185e9a7708fac60d986a7.png";